import { z } from "zod";

export const RootFactNodeContentSchema = z.object({
  nodeType: z.literal("root"),
  version: z.literal("1"),
});
